import {
    STATISTIC_DATA_LOADING,
    STATISTIC_DATA_LOADED,
    CLEAR_STATISTIC_DATA,
    DETAILED_STATISTIC_LOADING,
    DETAILED_STATISTIC_LOADED,
    DETAILED_STATISTIC_DOWNLOADING,
    DETAILED_STATISTIC_DOWNLOADED,
    MONITOR_CHART_DATA_LOADED,
    MONITOR_CHART_DATA_LOADING, TB_STATISTIC_LOADING, TB_STATISTIC_LOADED, STATISTIC_DATA_LOADED_WITH_ERRORS,
} from '../../actions/actionTypes';
import {
    OPERATOR_DEDUCTION_KOEFF,
    OPERATOR_KOEFF,
    PARTNER_KOEFF,
    PRICE, REFERRER_INCOME,
    ROYALTIES_KOEFF
} from "../../utils/constants";


const disabledLineChartColumns = [PRICE, OPERATOR_DEDUCTION_KOEFF, OPERATOR_KOEFF, PARTNER_KOEFF, ROYALTIES_KOEFF, REFERRER_INCOME];

const initialState = {
    loadedData: [],
    tableColumns: [],
    tableData: [],
    tableResult: null,
    chartData: [],
    selectedFilterPreset: null,
    selectedColumnsPreset: null,
    loading: false,
    detailedStatisticData: [],
    loadingDetailedStatistic: false,
    downloadingDetailedStatistic: false,
    loadingMonitorChartData: false,
    tbStatisticData: [],
    loadingTbStatistic: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case STATISTIC_DATA_LOADING:
            return {
                ...state,
                tableColumns: [],
                lineChartColumns: [],
                loadedData: [],
                tableData: [],
                chartData: [],
                loading: true
            };
        case STATISTIC_DATA_LOADED:
            const loadedData = action.payload.statisticData.statistic;
            const columns = action.payload.statisticData.columns;
            const chartData = action.payload.chartData?.statistic;
            return state.loading
                ? {
                ...state,
                tableColumns: columns,
                lineChartColumns: columns.filter(column => !disabledLineChartColumns.includes(column.name)),
                loadedData: loadedData,
                tableData: [...loadedData],
                chartData: [...chartData],
                loading: false,
            }
            : state;
        case STATISTIC_DATA_LOADED_WITH_ERRORS:
            return {
                ...state,
                loading: false,
                loadingDetailedStatistic: false,
                loadingMonitorChartData: false,
                loadingTbStatistic: false,
            };
        case DETAILED_STATISTIC_LOADING:
            return {
                ...state,
                detailedStatisticData: [],
                loadingDetailedStatistic: true,
            };
        case DETAILED_STATISTIC_LOADED:
            return {
                ...state,
                detailedStatisticData: action.payload,
                loadingDetailedStatistic: false,
            };
        case CLEAR_STATISTIC_DATA:
            return {
                loadedData: [],
                tableColumns: [],
                lineChartColumns: [],
                tableData: [],
                tableResult: null,
                chartData: [],
                selectedFilterPreset: null,
                selectedColumnsPreset: null,
                loading: false,
                loadingMonitorChartData: false,
            };
        case DETAILED_STATISTIC_DOWNLOADING:
            return  {
                ...state,
                downloadingDetailedStatistic: true,
            };
        case DETAILED_STATISTIC_DOWNLOADED:
            return  {
                ...state,
                downloadingDetailedStatistic: false,
            };
        case MONITOR_CHART_DATA_LOADING:
            return  {
                ...state,
                loadingMonitorChartData: true,
            };
        case MONITOR_CHART_DATA_LOADED:
            return  {
                ...state,
                loadingMonitorChartData: false,
                chartData: action.payload.statistic,
                lineChartColumns: action.payload.columns.filter(column => !disabledLineChartColumns.includes(column.name)),
            };
        case TB_STATISTIC_LOADING:
            return {
                ...state,
                tbStatisticData: [],
                loadingTbStatistic: true,
            };
        case TB_STATISTIC_LOADED:
            return {
                ...state,
                tbStatisticData: action.payload,
                loadingTbStatistic: false,
            };
        default:
            return state;
    }
}
